import React from 'react';
import { Information } from "src/components/login/Information";
import ForgotPassword from '../@jumbo/components/Common/authComponents/ForgotPassword';

const ForgotPasswordPage = () => (
  <>
    <Information />
    <ForgotPassword variant="standard" wrapperVariant="bgColor" />
  </>
);

export default ForgotPasswordPage;
